<template>
  <div>
    <v-row no-gutters v-for="file in sortedAttachments" :key="file.id">
      <component
        :is="expanded ? 'TheAttachmentExpanded' : 'TheAttachment'"
        :attachment="file"
        :form-schema="formSchema"
        :layer-id="layerId"
        :feature-id="featureId"
        @deleteFile="$emit('deleteFile', $event)"
      />
    </v-row>
  </div>
</template>

<script>
import { get } from 'vuex-pathify';
import { getIconColorByFileType, getIconByFileType } from '@/assets/js/utility';

import TheAttachment from '@/components/TheAttachment';
import TheAttachmentExpanded from '@/components/TheAttachmentExpanded';

export default {
  components: {
    TheAttachment,
    TheAttachmentExpanded,
  },
  name: 'AttachmentList',
  props: {
    attachments: {
      type: Array,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    formSchema: {
      type: Array,
      default: () => {
        return [];
      },
    },
    layerId: {
      type: [String, Number],
      required: true,
    },
    featureId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    currentUser: get('users/currentUser'),
    token: get('authentication/token'),
    users: get('users/users'),
    documentationLayerId: get('admin/modulesMapping@documentation.documentation_layer_id'),
    currentLayer: get('layers/layers@:layerId'),
    layerPermissions: get('users/layersPermissions@:layerId'),
    layerImageAttributes() {
      return this.currentLayer?.image_attributes || [];
    },
    computedAttachments() {
      return JSON.parse(JSON.stringify(this.attachments)).map(item => {
        const { added_at, assigned_at, added_by, filename, id, name, is_photo } = item.properties;
        const properties = item.properties;
        delete item.properties;
        return {
          ...item,
          properties,
          id,
          name,
          filename,
          is_photo,
          is_pdf: filename?.toLowerCase().includes('.pdf'),
          icon: getIconByFileType(filename),
          iconColor: getIconColorByFileType(filename),
          date: this.$dayjs(added_at).format('L'),
          thumbnailUrl: `${process.env.VUE_APP_API_URL}/attachments/${id}/thumbnail?token=${this.token}`,
          fileRelativeUrl: `/attachments/${id}/file`,
          subheader: `${this.users[added_by]?.name ? `${this.users[added_by]?.name},` : ''} ${this.$dayjs(
            assigned_at
          ).format('L')}`,
          dotsItems: this.getDotsItems(this.hasPermissions(added_by), is_photo),
        };
      });
    },
    sortedAttachments() {
      const cA = this.computedAttachments;
      cA.sort((a, b) => {
        return this.$dayjs(a['assigned_at'])?.isAfter(this.$dayjs(b['assigned_at'])) ? -1 : 1;
      });
      return cA;
    },
  },
  methods: {
    getDotsItems(value, isPhoto) {
      return [
        ...(this.expanded && this.documentationLayerId
          ? [
              {
                name: 'openDocument',
              },
            ]
          : []),
        ...(this.layerImageAttributes?.length && isPhoto
          ? [
              {
                name: 'setProfileImage',
              },
            ]
          : []),
        {
          name: 'delete',
          disabled: !value,
        },
        {
          name: 'download',
        },
      ];
    },
    hasPermissions(id) {
      return (
        this.currentUser.is_admin ||
        this.currentUser.is_superadmin ||
        id === this.currentUser.id ||
        this.layerPermissions.main_value === 2
      );
    },
  },
};
</script>

<style scoped lang="scss"></style>
